<template>
  <div class="quality-mark__row">
    <div class="quality-mark__checkbox">
      <Checkbox v-model="mark.enabled" />
    </div>
    <div class="quality-mark__url">
      <span>
        <label class="quality-mark__url__label">
          {{ mark.name }}
        </label>
      </span>
      <span class="quality-mark__url__body">
        <TextInput
          :disabled="!mark.enabled || mark.readOnly"
          :label="placeholder"
          enableExternalValidation
          :externalValidationError="urlError"
          :externalValidationErrorMessage="urlErrorMessage"
          hide-label-on-input
          v-model="mark.link"
        ></TextInput>
      </span>
    </div>
    <div class="quality-mark__logo">
      <img class="quality-mark__logo__img" :src="mark.logo" />
    </div>
  </div>
</template>

<script>
import Checkbox from "../atoms/Inputs/Checkbox.vue";
import TextInput from "../atoms/Inputs/TextInput.vue";
import FormMixin from "../mixins/FormMixin";

export default {
  name: "QualityMark",
  mixins: [FormMixin],
  props: {
    /* Required object that should have name, enabled, link and logo properties.
     */
    mark: {
      type: Object,
      required: true,
    },
    urlError: {
      type: Boolean,
    },
    urlErrorMessage: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "https://examp.le",
    },
  },
  components: {
    Checkbox,
    TextInput,
  },
};
</script>
<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";
@import "~include-media";

.quality-mark__row {
  display: flex;
  align-items: flex-start;
}
.quality-mark__checkbox {
  padding-top: 52px;
  padding-right: 12px;
}
.quality-mark__logo {
  height: 55px;
  width: 125px;
  margin-top: 36px;
  margin-left: 12px;

  @include media($isPhone...) {
    display: none;
  }
}
.quality-mark__logo__img {
  height: 100%;
  max-width: 100%;
  object-fit: scale-down;
}
.quality-mark__url {
  width: 100%;
  max-width: 400px;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  grid-template-areas:
    "label"
    "body";

  .quality-mark__url__body {
    grid-area: body;
  }
}
.quality-mark__url__body::v-deep .text_input__input {
  @extend %body3_style;
  &.text_input__input--disabled {
    color: $grey_mischka;
  }
}
.quality-mark__url__label {
  @extend %subtitle3_style;
}
</style>
